import { v4 as uuidv4 } from 'uuid';
import { StringUtil } from 'src/utils';
import moment from 'moment';

interface RegistrationListItemDTO {
  id: string
  created: moment.Moment | null;
  lastActivity: moment.Moment | null;
  pCName: string;
  productCode: string;
  publicIP: string;
  version: string;
  disable: boolean;
}
const RegistrationListItemDTO = {
  create: (initValues?: Partial<RegistrationListItemDTO>): RegistrationListItemDTO => {
    const defaults: RegistrationListItemDTO = {
      id: '',
      created: null,
      lastActivity: null,
      pCName: '',
      productCode: '',
      publicIP: '',
      version: '',
      disable: false,
    };
    const fixedInitValues: Partial<RegistrationListItemDTO> = initValues != null
      ? {
        id: StringUtil.IsNullOrEmpty(initValues.id) ? uuidv4() : initValues.id,
      }
      : {};
    return { ...defaults, ...initValues, ...fixedInitValues };
  },
};

export default RegistrationListItemDTO;
